export default "__VITE_ASSET__tqEHjY9T__"